import React, { useEffect, useState } from "react";

import Pagination from "react-js-pagination";

import UserList from "../../components/UserList";
// import UserService from "../../services/UserService";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";

import "./users.scss";

const Index: React.FC<any> = (props) => {
  // const { token } = props.state;
  const [users] = useState([]);
  // const [searchInput, setSearchInput] = useState("");

  const [activePage, setActivePage] = useState(1);
  const [total] = useState(0);
  const [error] = useState(false);
  const [loading] = useState(false);

  // const getTotalUsers = () => {
  //   UserService.getTotalUsers(token)
  //     .then((response) => {
  //       setTotal(response);
  //       setLoading(false);
  //     })
  //     .catch((error) => {
  //       setError(true);
  //       setLoading(false);
  //     });
  // };

  // const getBuyers = () => {
  //   setLoading(true);
  //   BuyerService.getBuyers(token, activePage)
  //     .then((response) => {
  //       if (response && response.length > 0) {
  //         setUsers(response);
  //       }
  //       setLoading(false);
  //     })
  //     .catch((error) => {
  //       setLoading(false);
  //       setError(true);
  //     });
  // };

  // const searchBuyers = (input) => {
  //   BuyerService.searchBuyers(token, activePage, input)
  //     .then((response) => {
  //       if (response && response.length > 0) {
  //         setUsers(response);
  //       }
  //     })
  //     .catch((error) => {
  //       setError(true);
  //     });
  // };

  useEffect(() => {
    // getBuyers();
    // getTotalUsers();
    // eslint-disable-next-line
  }, []);

  // useEffect(() => {
  //   if (searchInput !== "") {
  //     searchBuyers(searchInput);
  //   } else {
  //     getBuyers();
  //   }

  //   // eslint-disable-next-line
  // }, [activePage]);

  const handlePageChange = (pageNumber: number) => {
    setActivePage(pageNumber);
  };

  const search = (value: any) => {
    // setSearchInput(value);
    // searchBuyers(value);
  };

  return (
    <div className="dashboard-container">
      {loading && (
        <div className={"loading-mask"}>
          <FontAwesomeIcon icon={faCircleNotch} pulse />
        </div>
      )}

      <h1>Usuários</h1>
      <UserList users={users} error={error} search={search} />
      <div className="user-list-pagination">
        <div className="user-list-pagination-item">
          <p>
            Mostrando {users && users.length} de {total} usuários
          </p>
        </div>
        <div className="user-list-pagination-item">
          <Pagination
            activePage={activePage}
            itemsCountPerPage={10}
            totalItemsCount={total}
            onChange={handlePageChange}
            itemClass="page-item"
            linkClass="page-link-pagination"
            prevPageText="<< Anterior"
            nextPageText="Próxima >>"
            hideFirstLastPages={true}
          />
        </div>
      </div>
    </div>
  );
}

export default Index